import styled, { keyframes, css } from 'styled-components';
import { Icon, IconButton } from '@web-chat-core/ui-kit';
import { MOBILE_STAGE_VIEW_WIDTH } from 'consts';

const messageBounce = keyframes`
  0% {
    transform: translateY(0);
  }
  15% {
    transform: translateY(-32px);
  }
  30% {
    transform: translateY(0);
  }
  45% {
    transform: translateY(-14px);
  }
  60% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0);
  }
`;

const messageBounceMobile = keyframes`
  0% {
    transform: translateY(0);
  }
  15% {
    transform: translateY(10px);
  }
  30% {
    transform: translateY(0);
  }
  45% {
    transform: translateY(4px);
  }
  60% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(1px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const ChatLayoutButton = styled(IconButton)<{ $active: boolean }>`
    height: 40px;
    width: 40px;

    &.animating {
        animation: ${css`
            ${messageBounce} 0.8s ease-out
        `};
    }

    @media screen and (max-width: ${MOBILE_STAGE_VIEW_WIDTH}px) {
        height: 32px;
        width: 32px;

        &.animating {
            animation: ${css`
                ${messageBounceMobile} 0.8s ease-out
            `};
        }
    }

    &:before {
        background-color: ${(props) =>
            props.$active
                ? props.theme.root.colors.basicColors['80%']
                : props.theme.root.colors.basicColors['10%']}!important;

        @media screen and (max-width: 991px) {
            border-radius: 6px;
            height: 32px;
            width: 32px;
        }
    }

    &:hover:before {
        background-color: ${(props) =>
            props.$active ? 'rgba(255, 255, 255, 0.90)' : props.theme.root.colors.basicColors['15%']}!important;
    }

    &:after {
        right: 0;
        left: auto;
        transform: translateY(-100%);
        white-space: nowrap;
    }
`;

export const NewMessageBage = styled.div<{ hasNewMessage: boolean }>`
    position: relative;
    &:before {
        z-index: 2;
        width: 8px;
        height: 8px;
        position: absolute;
        left: 100%;
        border-radius: 50%;
        border: 1px solid ${(props) => props.theme.root.colors.background['01Base']};
        transform: translateX(-75%);
        ${({ hasNewMessage }) => hasNewMessage && 'content: " ";'}
        background: ${(props) => props.theme.root.colors.primary.hover}
    }
`;
export const ChatIcon = styled(Icon)<{ $active: boolean }>`
    fill: ${({ $active, theme }) =>
        $active ? theme.root.colors.basicColors.black['95%'] : theme.root.colors.basicColors['90%']};
`;
